import { render, staticRenderFns } from "./import-substitution-request-create-ktru-item-block.vue?vue&type=template&id=3647b03a&scoped=true&"
import script from "./import-substitution-request-create-ktru-item-block.vue?vue&type=script&lang=js&"
export * from "./import-substitution-request-create-ktru-item-block.vue?vue&type=script&lang=js&"
import style0 from "./import-substitution-request-create-ktru-item-block.vue?vue&type=style&index=0&id=3647b03a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3647b03a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3647b03a')) {
      api.createRecord('3647b03a', component.options)
    } else {
      api.reload('3647b03a', component.options)
    }
    module.hot.accept("./import-substitution-request-create-ktru-item-block.vue?vue&type=template&id=3647b03a&scoped=true&", function () {
      api.rerender('3647b03a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/import-substitution/import-substitution-request-create-ktru-item-block.vue"
export default component.exports